import { render, staticRenderFns } from "./orderStatementReturnedSummaryBox.vue?vue&type=template&id=4c7a88c2&"
import script from "./orderStatementReturnedSummaryBox.vue?vue&type=script&lang=ts&"
export * from "./orderStatementReturnedSummaryBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports